import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import useConfirmStore from '../hooks/useConfirm';

const GlobalConfirmModal = () => {
  const { darkMode } = useTheme();
  const { isOpen, title, message, onConfirm, type, confirmText, cancelText, closeConfirm } = useConfirmStore();

  if (!isOpen) return null;

  const typeColors = {
    danger: 'bg-red-600 hover:bg-red-700',
    warning: 'bg-yellow-600 hover:bg-yellow-700',
    info: 'bg-blue-600 hover:bg-blue-700',
  };

  const iconColors = {
    danger: 'bg-red-100 text-red-600',
    warning: 'bg-yellow-100 text-yellow-600',
    info: 'bg-blue-100 text-blue-600',
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black bg-opacity-50" onClick={closeConfirm}>
      <div 
        className={`relative w-full max-w-md rounded-lg shadow-xl ${darkMode ? 'bg-zinc-800' : 'bg-white'}`}
        onClick={e => e.stopPropagation()}
      >
        <div className="p-6">
          <div className="flex items-start gap-4">
            <div className={`flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center ${iconColors[type]}`}>
              <AlertTriangle className="h-6 w-6" />
            </div>
            <div className="flex-1">
              <h3 className={`text-lg font-semibold mb-2 ${darkMode ? 'text-white' : 'text-gray-900'}`}>
                {title}
              </h3>
              <p className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                {message}
              </p>
            </div>
            <button
              onClick={closeConfirm}
              className={`flex-shrink-0 ${darkMode ? 'text-gray-400 hover:text-white' : 'text-gray-400 hover:text-gray-600'}`}
            >
              <X className="h-5 w-5" />
            </button>
          </div>
        </div>
        
        <div className={`flex gap-3 px-6 py-4 ${darkMode ? 'bg-zinc-900' : 'bg-gray-50'} rounded-b-lg`}>
          <button
            onClick={closeConfirm}
            className={`flex-1 px-4 py-2 rounded-lg font-medium transition-colors ${
              darkMode 
                ? 'bg-zinc-700 text-white hover:bg-zinc-600' 
                : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-300'
            }`}
          >
            {cancelText}
          </button>
          <button
            onClick={() => {
              onConfirm();
              closeConfirm();
            }}
            className={`flex-1 px-4 py-2 rounded-lg font-medium text-white transition-colors ${typeColors[type]}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GlobalConfirmModal;
